import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { publicGuard } from './core/guards/public.guard';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [publicGuard],
    loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'forgot-password',
    canActivate: [publicGuard],
    loadComponent: () => import('./features/auth/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent)
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent)
  },
  {
    path: 'case/new',
    canActivate: [authGuard],
    loadComponent: () => import('./features/case-intake/case-intake.component').then(m => m.CaseIntakeComponent)
  },
  {
    path: 'case/:id/edit',
    canActivate: [authGuard],
    loadComponent: () => import('./features/case-edit/case-edit.component').then(m => m.CaseEditComponent)
  },
  {
    path: 'case/:id',
    canActivate: [authGuard],
    loadComponent: () => import('./features/case-details/case-details.component').then(m => m.CaseDetailsComponent)
  },
  {
    path: 'tasks',
    canActivate: [authGuard],
    loadComponent: () => import('./features/tasks/tasks-page.component').then(m => m.TasksPageComponent)
  },
  { path: '**', redirectTo: 'login' }, // Redirect any unknown paths to auth/login
];
